var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityListPage',{attrs:{"entityName":"listiniTariffeInternazionali","pageTitle":"Tariffe Listini","allowAdd":true,"allowEdit":true}})}
var staticRenderFns = []

export { render, staticRenderFns }